module.exports = __webpack_public_path__ + "media/assets/images/blog/TESTA-LINKEDIN-3logo.jpg-small-f9b3fe80262522297a8c762482ad899a.png";